import { useQuery } from '@tanstack/react-query';
import { useRouter } from '@power-core/toolkit';
import { getProjectInfoServer } from '@/shared/project/api/project.api';
import { useSearchParams } from 'next/navigation';
import { useFilters } from '@/shared/filters/hooks/use-filters.hook';
import { setProject } from '../utils/project.util';
import { useSetAtom } from 'jotai';
import { cartAtom } from '@/shared/cart/utils/cart.util';

export const useGetProjectData = () => {
	const params = useSearchParams();
	const router = useRouter();
	const { setProjectFilters, setCountryCode, setLifeCyclePhase, filters } = useFilters();
	const setCart = useSetAtom(cartAtom);
	const { downstream, upstream, type } = filters;

	const { isPending } = useQuery({
		queryKey: ['PROJECT_DATA'],
		queryFn: async () => {
			const projectId = params.get('projectId') || '';
			const toolUrl = params.get('toolUrl') || '';

			if (!projectId) return null;

			const { projectName, customerName, countryCode, representative, fileContent, error, message, details } = await getProjectInfoServer({
				projectId,
				toolUrl,
			});

			setProject({ projectId, customerName, representative });
			setCountryCode(countryCode);

			if (error) {
				console.warn('Error fetching project data:', details, message);
				router.replace(`/`);
			}

			if (fileContent) {
				setProjectFilters({
					upstream: fileContent.upstream,
					downstream: fileContent.downstream,
					type: fileContent.type,
					countryCode: fileContent.countryCode || countryCode,
					lifeCyclePhase: fileContent.lifeCyclePhase || 'Active',
				});
				setCountryCode(fileContent.countryCode);
				setLifeCyclePhase(fileContent.lifeCyclePhase);
				setCart({
					chain: fileContent.cart,
					selectedChain: Object.keys(fileContent.cart)[0],
					mode: null,
				});
				setProject({
					projectName,
					countryCode: fileContent.countryCode || countryCode,
					lifeCyclePhase: fileContent.lifeCyclePhase === 'Active' ? 'Active' : '',
				});
				router.replace(`/${fileContent.type}?${params.toString()}`);

				return {
					upstream: fileContent.upstream,
					downstream: fileContent.downstream,
					type: fileContent.type,
				};
			}

			setProject({ projectName });

			return {
				upstream,
				downstream,
				type,
			};
		},
		refetchOnWindowFocus: false,
	});

	return {
		isPending,
	};
};
